import { useHttpClient } from "@/common/api/httpClient";
import type { StorageAreaResponse } from "./models/storageAreaResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";
import { useStorageAreaStore } from "shared/storageAreas/stores/storageAreaStore";

export interface PlaceDisplayText {
  id: string;
  displayText: string | null;
}

export interface StorageAreaDisplayText {
  id: string;
  displayText: string | null;
  places?: PlaceDisplayText[];
}

export interface UpdateDisplayTextsRequest {
  storageAreas: StorageAreaDisplayText[];
}

export interface UpdateDisplayTextsResponse {
  ok: true;
  storageAreas: StorageAreaResponse[];
}

export function useUpdateDisplayTexts() {
  const httpClient = useHttpClient();
  const store = useStorageAreaStore();

  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute(action: UpdateDisplayTextsRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('storagearea/display-texts'), {
      headers,
      method: 'PUT',
      body: JSON.stringify(action),
    });

    const text = translations.value.storageAreas.actions.update;

    const response = await httpClient.action<UpdateDisplayTextsResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as StorageAreaResponse[];
        for (const storageArea of json) {
          store.add(storageArea);
        }
        return {
          ok: true,
          storageAreas: json,
        };
      },
    });

    return response;
  }
}
